import { gql, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  PatientDetailQuery,
} from "~/graphql/__generated__/graphql";
import SchedulerScreen from "~/components/scheduler/SchedulerScreen";

export default function SchedulerPatientScreen() {
  const { patientId } = useParams();

  const { data, loading } = useQuery<PatientDetailQuery>(PATIENT_QUERY, {
    variables: {
      patientId: parseInt(`${patientId}`),
      // currentTime
    },
    onError(error) {
      console.error(error);
    },
  });
  const patient = data?.patientSingle;

  return <SchedulerScreen selectedPatient={patient} loading={loading} key={`${patient?.id}-${patient?.updatedAt}`} />;
}

const PATIENT_QUERY = gql`
  query PatientDetail($patientId: Int)
  @permission(requires: useWebApp)
  {
    patientSingle(where: { id: { eq: $patientId } }) {
      id
      firstName
      lastName
      phone
      preferredLanguage
      sex
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressCoordinates
      addressTimezone
      dateOfBirth
      patientNotes
      serviceInstructions
      organizationId
      updatedAt

      episodes {
        id
        active
        serviceLineId
        organizationalUnitId
        updatedAt
        precautions {
          id
          precautionId
        }
      }

      patientIdentifiers {
        identifier
        identifier_type
      }

      visits {
        id
        startTime
        endTime
        eventStatus
        addressStreet
        addressLineTwo
        addressCity
        addressState
        addressZip
        addressCoordinates
        addressTimezone
        serviceInstructions
        episode {
          serviceLineId
        }
        visitResources {
          providerId
          provider {
            id
            firstName
            lastName
          }
        }
        visitType {
          id
          name
        }
        visitServices {
          id
          serviceId
          service {
            id
            name
          }
        }
      }
    }
  }
`;
